import Vue from 'vue'
import Router from 'vue-router'

import store from '@vuex'
import config from '@conf'
import { routerScopes } from './const'

import { resolveRedirect } from './redirect'

// route components:
import Auth from '@vue/auth/Auth'
import Login from '@vue/auth/Login.vue'
import Signup from '@vue/auth/Signup.vue'
import Recovery from '@vue/auth/Recovery.vue'
import EmailResend from '@vue/auth/ConfirmEmail.vue'

import AppContent from '@vue/root/AppContent.vue'

// Main section
import Dashboard from '@vue/app/dashboard/Dashboard.Entry'
import DashboardOldIndex from '@vue/app/dashboard/index/Dashboard.Old.Index'
import DashboardIndex from '@vue/app/dashboard/index/Dashboard.Index'

import History from '@vue/app/history/History.Entry'
import HistoryIndex from '@vue/app/history/index/History.Index'
// end Main section

// Transaction section
import TopupBalance from '@vue/app/topupBalance/TopupBalance.Entry'
import TopupBalanceMake from '@vue/app/topupBalance/make/TopupBalance.Make'

import Withdrawal from '@vue/app/withdrawal/Withdrawal.Entry'
import WithdrawalMake from '@vue/app/withdrawal/make/Withdrawal.Make'

import Transfers from '@vue/app/transfers/Transfers.Entry'
import TransfersMake from '@vue/app/transfers/make/Transfers.Make'

import MassTransfers from '@vue/app/massTransfers/MassTransfers.Entry'
import MassTransfersMake from '@vue/app/massTransfers/MassTransfers.Make'
// end Transaction section

// Campaign section
import SaleCreation from '@vue/app/saleCreation/SaleCreation.Entry'
import SaleCreationIndex from '@vue/app/saleCreation/SaleCreation.Index'

import Sales from '@vue/app/sales/Sales.Entry'
import SalesDetails from '@vue/app/sales/sale_details/Sales.Details'
import SalesExplore from '@vue/app/sales/overview/Sales.Explore'

import SalesOwned from '@vue/app/salesOwned/SalesOwned.Entry'
import SalesOwnedIndex from '@vue/app/salesOwned/SalesOwned.Index'

import Portfolio from '@vue/app/portfolio/Portfolio.Entry'
import PortfolioIndex from '@vue/app/portfolio/Portfolio.Index'

import Requests from '@vue/app/requests/Requests.Entry'
import RequestsIndex from '@vue/app/requests/index/Requests.Index'
// end Campaign section

import Fee from '@vue/app/fee/Fee.Entry'
import FeeIndex from '@vue/app/fee/index/Fee.Index'

import Limits from '@vue/app/limits/Limits.Entry'
import LimitsIndex from '@vue/app/limits/Limits.Index'

import Trade from '@vue/app/trade/Trade.Entry'
import TradeIndex from '@vue/app/trade/index/Trade.Index'

import Settings from '@vue/app/settings/Settings.Entry'
import SettingsSecurity from '@vue/app/settings/security/Settings.Security'

import Verification from '@vue/app/verification/Verification.Entry'
import VerificationMake from '@vue/app/verification/make/Verification.Make'

import ExchangeEntry from '@vue/app/exchange/Exchange.Entry'
import ExchangeIndex from '@vue/app/exchange/index/Exchange.Index'

import Contracts from '@vue/app/contracts/Contracts.Entry'
import ContractsIndex from '@vue/app/contracts/index/Contracts.Index'

import Tokens from '@vue/app/tokens/Tokens.Entry'
import TokensExplore from '@vue/app/tokens/Tokens.Explore'

import Cashbox from '@vue/app/cashbox/Cashbox.Entry'
import CashboxIndex from '@vue/app/cashbox/index/Cashbox.Index'
import WidrawalRequestIndex from '@vue/app/widrawalRequest/WidrawalRequest.Index'
import RefundHistoryIndex from '@vue/app/refundHistory/RefundHistory.Index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: { name: 'app' }
    },
    {
      path: '/r/*',
      name: 'horizon-redirect',
      beforeEnter: resolveRedirect
    },
    {
      path: '/auth',
      name: routerScopes.auth,
      component: Auth,
      redirect: { name: 'login' },
      children: [
        {
          path: '/sign-in',
          name: 'login',
          component: Login,
          beforeEnter: authPageGuard
        },
        {
          path: '/sign-up',
          name: 'signup',
          component: Signup,
          beforeEnter: authPageGuard
        },
        {
          path: '/verify-email',
          name: 'email',
          component: EmailResend,
          beforeEnter: authPageGuard
        },
        {
          path: '/recovery',
          name: 'recovery',
          component: Recovery,
          beforeEnter: authPageGuard
        }
      ]
    },
    {
      path: '/',
      name: routerScopes.app,
      component: AppContent,
      beforeEnter: inAppRouteGuard,
      redirect: { name: 'app.dashboard' },
      children: [
        {
          feature_flag: config.FEATURE_FLAGS.dashboard,
          name: 'app.dashboard',
          path: '/dashboard',
          component: Dashboard,
          redirect: { path: '/dashboard/index' },
          children: [
            {
              path: '/dashboard/index',
              name: 'dashboard.index',
              component: DashboardIndex
            },
            {
              path: '/old-dashboard/index',
              name: 'dashboard.old.index',
              component: DashboardOldIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.exchange,
          name: 'app.exchange',
          path: '/exchange',
          component: ExchangeEntry,
          redirect: { path: '/exchange/index' },
          children: [
            {
              path: '/exchange/index',
              name: 'Exchange.Index',
              component: ExchangeIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.history,
          name: 'app.history',
          path: '/history',
          component: History,
          redirect: { path: '/history/index' },
          children: [
            {
              path: '/history/index',
              name: 'history.index',
              component: HistoryIndex
            },
            {
              path: '/history/index/:tokenCode',
              name: 'history.index:tokenCode',
              component: HistoryIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.topupBalance,
          name: 'app.TopupBalance',
          path: '/topup-balance',
          component: TopupBalance,
          beforeEnter: async (to, from, next) => {
            if (!store.state.timer.timer) {
              await store.dispatch('startTimer', {
                reactivateWallet: false,
                needCheckForm: true
              })
            }
            next()
          },
          redirect: { path: '/topup-balance/make' },
          children: [
            {
              path: '/topup-balance/make',
              name: 'topup-balance.make',
              component: TopupBalanceMake
            },
            {
              path: '/topup-balance/xpay-confirm',
              name: 'topup-balance.make',
              component: TopupBalanceMake,
              props: (route) => ({ state: route.query.state, xrayOperationID: route.query.xrayOperationID })
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.cashbox,
          name: 'app.cashbox',
          path: '/cashbox',
          component: Cashbox,
          redirect: { path: '/cashbox/index' },
          children: [
            {
              path: '/cashbox/index',
              name: 'Cashbox.Index',
              component: CashboxIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.withdrawal,
          name: 'app.withdrawal',
          path: '/withdrawal',
          component: Withdrawal,
          beforeEnter: withdrawalLevelGuard,
          redirect: { path: '/withdrawal/make' },
          children: [
            {
              path: '/withdrawal/make',
              name: 'withdrawal.make',
              component: WithdrawalMake
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.refundHistory,
          name: 'app.refundHistory',
          path: '/refund-history',
          component: RefundHistoryIndex,
          redirect: { path: '/refund-history/index' },
          children: [
            {
              path: '/refund-history/index',
              name: 'refundHistory.index',
              component: RefundHistoryIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.widrawalRequest,
          name: 'app.widrawalRequest',
          path: '/withdrawal-req',
          component: WidrawalRequestIndex,
          redirect: { path: '/withdrawal-req/index' },
          children: [
            {
              path: '/withdrawal-req/index',
              name: 'widrawalRequest.index',
              component: WidrawalRequestIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.transfers,
          name: 'app.transfers',
          path: '/transfers',
          component: Transfers,
          redirect: { path: '/transfers/make' },
          children: [
            {
              path: '/transfers/make',
              name: 'transfers.make',
              component: TransfersMake
            },
            {
              path: '/transfers/make/:tokenCode&amount=:amount&recipient=:recipient&subject=:subject&convert=:convert',
              name: 'transfers.make:tokenCode',
              component: TransfersMake,
              props: true
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.massTransfers,
          name: 'app.mass-transfers',
          path: '/mass-transfers',
          component: MassTransfers,
          redirect: { path: '/mass-transfers/make' },
          children: [
            {
              path: '/mass-transfers/make',
              name: 'mass-transfers.make',
              component: MassTransfersMake
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.saleCreation,
          name: 'app.saleCreation',
          path: '/sale-creation',
          component: SaleCreation,
          redirect: { path: '/sale-creation/index' },
          children: [
            {
              path: '/sale-creation/index',
              name: 'sale-creation.index',
              component: SaleCreationIndex,
              props: true
            },
            {
              path: '/sale-creation/index/:id',
              name: 'sale-creation.index:id',
              component: SaleCreationIndex,
              props: true
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.sales,
          name: 'app.sales',
          path: '/sales',
          component: Sales,
          redirect: { path: '/sales/explore' },
          children: [
            {
              path: '/sales/explore',
              name: 'sales.explore',
              component: SalesExplore
            },
            {
              path: '/sales/details/:id',
              name: 'sales.sale-details',
              component: SalesDetails,
              props: true
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.sales,
          name: 'app.my-sales',
          path: '/my-sales',
          component: SalesOwned,
          redirect: { path: '/my-sales/index' },
          children: [
            {
              path: '/my-sales/index',
              name: 'my-sales.index',
              component: SalesOwnedIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.contracts,
          name: 'app.contracts',
          path: '/contracts',
          component: Contracts,
          redirect: { path: '/contracts/index' },
          children: [
            {
              path: '/contracts/index',
              name: 'contracts.index',
              component: ContractsIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.portfolio,
          name: 'app.portfolio',
          path: '/portfolio',
          component: Portfolio,
          redirect: { path: '/portfolio/index' },
          children: [
            {
              path: '/portfolio/index',
              name: 'portfolio.index',
              component: PortfolioIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.myFees,
          name: 'app.fee',
          path: '/fee',
          component: Fee,
          redirect: { path: '/fee/index' },
          children: [
            {
              path: '/fee/index',
              name: 'fee.index',
              component: FeeIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.limits,
          name: 'app.limits',
          path: '/limits',
          component: Limits,
          redirect: {path: '/limits/index'},
          children: [
            {
              path: '/limits/index',
              name: 'limits.index',
              component: LimitsIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.trade,
          name: 'app.trade',
          path: '/trade',
          component: Trade,
          redirect: { path: '/trade/index' },
          children: [
            {
              path: '/trade/index',
              name: 'trade.index',
              component: TradeIndex
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.tokens,
          name: 'app.tokens',
          path: '/tokens',
          component: Tokens,
          redirect: { path: '/tokens/explore' },
          children: [
            {
              path: '/tokens/explore',
              name: 'tokens.explore',
              component: TokensExplore
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.settings,
          name: 'app.settings',
          path: '/settings',
          component: Settings,
          redirect: { path: '/settings/security' },
          children: [
            {
              path: '/settings/security',
              name: 'settings.security',
              component: SettingsSecurity,
              props: (route) => ({tfaRecovery: route.query.tfaRecovery})
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.verification,
          name: 'app.verification',
          path: '/verification',
          component: Verification,
          redirect: { path: '/verification/make' },
          children: [
            {
              path: '/verification/make',
              name: 'verification.make',
              component: VerificationMake
            }
          ]
        },
        {
          feature_flag: config.FEATURE_FLAGS.requests,
          name: 'app.requests',
          path: '/requests',
          component: Requests,
          redirect: { path: '/requests/index' },
          children: [
            {
              path: '/requests/index',
              name: 'requests.index',
              component: RequestsIndex
            },
            {
              path: '/requests/token-creation',
              name: 'requests.token-creation',
              component: RequestsIndex
            },
            {
              path: '/requests/sale-creation',
              name: 'requests.sale-creation',
              component: RequestsIndex
            }
          ]
        }
      ].filter(route => route.feature_flag !== false)
    }
  ]
})

router.beforeEach((to, from, next) => {
  const notVerified = store.getters.accountNotVerifiedYet

  if (notVerified && ['dashboard.index'].includes(to.name)) {
    return next({ name: 'app.settings' })
  }

  next()
})

export default router

// doesn't allow to visit auth page if user is already logged in
function authPageGuard (to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  isLoggedIn ? next({ name: 'app' }) : next()
}

// doesn't allow to visit in-app page if user is not already logged in
function inAppRouteGuard (to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  isLoggedIn ? next() : next({ name: 'login' })
}

function withdrawalLevelGuard (to, from, next) {
  const approvalLevel = Number(store.getters.approverData.approval_level)
  approvalLevel === 1 ? next() : next({ name: 'app' })
}



// WEBPACK FOOTER //
// ./src/vue-router/index.js